import { RUN_STATUS_LABELS, statusTone, type WorkflowStatus, type StatusTone } from '@swg/domain';
import { theme } from '../theme.js';

const TONE_STYLE: Record<StatusTone, { bg: string; fg: string; border: string }> = {
  neutral: { bg: '#EEF1F5', fg: '#5A6472', border: '#DCE1E8' },
  running: { bg: '#E3EEF5', fg: theme.color.primary, border: '#C7DEEC' },
  action: { bg: theme.color.warnBg, fg: theme.color.warnText, border: theme.color.warnBorder },
  success: { bg: '#E4F4EA', fg: '#1E7A44', border: '#BFE6CD' },
  warning: { bg: theme.color.warnBg, fg: theme.color.warnText, border: theme.color.warnBorder },
  error: { bg: '#FBE6E6', fg: '#A82A2A', border: '#EFC2C2' },
};

export function StatusBadge({ status }: { status: WorkflowStatus }) {
  const s = TONE_STYLE[statusTone(status)];
  return (
    <span
      style={{
        display: 'inline-block',
        fontSize: 11.5,
        fontWeight: 600,
        color: s.fg,
        background: s.bg,
        border: `1px solid ${s.border}`,
        borderRadius: 20,
        padding: '3px 10px',
        whiteSpace: 'nowrap',
      }}
    >
      {RUN_STATUS_LABELS[status]}
    </span>
  );
}
